import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';

import { CryptoPayout, CryptoPayoutStatus } from 'types/cryptoPayout';

import { formatDateLocal } from 'utils/date';
import { sortByDate } from 'utils/sort';
import { capitalizeFirstLetterLowercaseOthers } from 'utils/string';

import LABELS, { KEYS } from './keys';
import { CheckIcon, FailedIcon, Item, ItemValue, SectionWrapper, StyledItemName } from './styles';

export interface CryptoPayoutEventsSectionProps {
  payout: CryptoPayout;
}

export const CryptoPayoutEventsSection = ({ payout }: CryptoPayoutEventsSectionProps) => {
  const { t } = useTranslation();
  const sortedStatusHistory = sortByDate(payout.statusHistory, (s) => s.createdAt, 'asc');

  const getStatusIcon = (status: CryptoPayoutStatus) => {
    const isFailed = Boolean(KEYS.FAILED_STATUSES.find((failedStatus) => failedStatus === status));

    if (isFailed) {
      return <FailedIcon width={16} height={16} />;
    }

    return <CheckIcon width={16} height={16} />;
  };

  return (
    <Panel label={t(LABELS.TITLE)}>
      <SectionWrapper>
        {sortedStatusHistory.map((status) => (
          <Item key={`${status.createdAt}-${status.to}`}>
            <StyledItemName>
              {getStatusIcon(status.to)}
              {capitalizeFirstLetterLowercaseOthers(status.to)}
            </StyledItemName>
            <ItemValue>{formatDateLocal(status.createdAt)}</ItemValue>
          </Item>
        ))}
      </SectionWrapper>
    </Panel>
  );
};
